// Constants that defines sizes, classNames and ids which are used in compactMode and etc.
const CONSTANTS = {
  COMPACT_ROW_HEIGHT: 32,
  DEFAULT_ROW_HEIGHT: 42,
  EDITABLE_CELL_CLASS: 'ccfk-editable-cell',
  FOCUSABLE_CELL_CLASS: 'ccfk-focusable-cell-content',
  ROW_ACTION_BUTTON_CLASS: 'ccfk-row-action-button',
  ROW_DRAGGING_HEADER_CLASS: 'ccfk-row-drag-header',
  CELL_NO_PADDING: 'ccfk-cell-no-padding',
  ROW_ACTION_COLID: 'rowActionColId',
  SELECTION_COLID: 'selectionColId',
  ACTION_COLUMN_WIDTH: 34,
  COMPACT_ACTION_COLUMN_WIDTH: 28,
  TOGGLE_COLUMN_WIDTH: 48,
  COLORBAR_COLUMN_WIDTH: 66,
  CHECKBOX_COLUMN_WIDTH: 48,
  SELECTION_COLUMN_WIDTH: 52
};

// Check if the column is row action column
const isActionColumn = column => column.userProvidedColDef && column.userProvidedColDef.type === 'actionColumn';

// Check if the column is editable
const isEditable = column => column.colDef.editable;

// Check if the cellRenderer of the column is agGroupCellRenderer
const isGroupCell = column => column.colDef.cellRenderer !== 'agGroupCellRenderer';

// Check if a cell contains something should be focused when the cell is focused. For example cells of row action column
const hasFocusableContent = column =>
  column.colDef.cellClass &&
  typeof column.colDef.cellClass === 'string' &&
  column.colDef.cellClass.indexOf(CONSTANTS.FOCUSABLE_CELL_CLASS) !== -1;

// Get the column index from column id
const getColumnIndexById = (columnsArr, id) => columnsArr.findIndex(col => col.colId === id);

// Get columns that are able to be tab to. Like editable column or row action column.
const getTabableColumns = (gridColumns) => {
  const tabableColumns = [];
  gridColumns.forEach((col, index) => {
    if (isEditable(col) || hasFocusableContent(col)) {
      tabableColumns.push({
        id: col.colId,
        index
      });
    }
  });
  return tabableColumns;
};
// Focus the content of tabable cell when the cell is focused.
const focusCellRenderer = (params) => {
  const {
    api, columnApi, column, rowIndex
  } = params;
  const focusColumns = getTabableColumns(columnApi.getAllGridColumns());
  const isFocusableColumn = column && focusColumns.findIndex(col => col.id === column.colId) > -1;
  if (isFocusableColumn) {
    const rowNode = api.getDisplayedRowAtIndex(rowIndex);
    const cellColId = column.colId;
    const instanceParams = {
      columns: [`${cellColId}`],
      rows: [`${rowNode}`]
    };
    const cellRendererInstances = api.getCellRendererInstances(instanceParams);
    if (cellRendererInstances && rowNode && cellRendererInstances.length > 0) {
      const instance = cellRendererInstances.find(i => i.params.node.rowIndex === rowIndex);
      if (instance && instance.componentInstance) {
        setTimeout(() => {
          if (!column.context.focusCellForHover && !column.context.lastCell) {
            instance.componentInstance && instance.componentInstance.focus();
          } else {
            column.context.lastCell = false;
          }
        });
      }
    }
  }
};

const toggleCompactMode = ({ api, columnApi }) => {
  const { COMPACT_ROW_HEIGHT, DEFAULT_ROW_HEIGHT, ROW_ACTION_COLID, COMPACT_ACTION_COLUMN_WIDTH, ACTION_COLUMN_WIDTH } = CONSTANTS;
  // eslint-disable-next-line no-param-reassign
  api.context.compactMode = !api.context.compactMode;
  api.stopEditing(true);
  const rowHeight = api.context.compactMode ? COMPACT_ROW_HEIGHT : DEFAULT_ROW_HEIGHT;
  api.forEachNode((node) => {
    node.setRowHeight(rowHeight);
  });
  api.onRowHeightChanged();
  api.setHeaderHeight(rowHeight);
  api.setGroupHeaderHeight(rowHeight);
  api.setFloatingFiltersHeight(rowHeight);
  // Change row action column width
  const columnStates = [...columnApi.getColumnState()];
  columnStates.forEach((colState) => {
    if (colState.colId === ROW_ACTION_COLID) {
      // eslint-disable-next-line no-param-reassign
      colState.width = api.context.compactMode ? COMPACT_ACTION_COLUMN_WIDTH : ACTION_COLUMN_WIDTH;
    }
  });
  columnApi.applyColumnState({
    state: columnStates
  });
  // Refresh cell renderers
  api.refreshHeader();
  api.refreshCells({ coloumns: [ROW_ACTION_COLID, 'ack'], force: true });
};

export {
  isActionColumn,
  isEditable,
  isGroupCell,
  hasFocusableContent,
  getColumnIndexById,
  getTabableColumns,
  focusCellRenderer,
  toggleCompactMode,
  CONSTANTS
};
